import { getStoredProceduresData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useStoreProceduresData = (transpilerId: string, disabled?: boolean) => {
  const data = useRestQuery(
    [QueryKey, 'getAllStoredProcedures', transpilerId],
    () => getStoredProceduresData(transpilerId),
    {
      retry: false,
      refetchOnMount: true,
      enabled: !!transpilerId && !disabled,
      sentryTag: 'transpiler.getAllStoredProceduresData'
    }
  );

  return data;
};
